module.exports = __webpack_public_path__ + "img/play.127f09ca.svg";